import { BrowserRouter } from 'react-router-dom';
import {About, Contact,Experience, Feedbacks,Navbar, Hero, 
  Tech,Works, StarsCanvas } from './components'

// bg is background
//template_wn2mrbw
//9QTEp6kC1snUdQGw7
function App() {
  return (
   <BrowserRouter>
   <div className='relative z-0 bg-primary'>  {/*z-0 is a default index value*/}
     <div className='bg-hero-pattern bg-cover'>
          <Navbar/>
          <Hero />
     </div>
     <About/>
     <Experience/>
     <Tech/>
    <Works/>
     <Feedbacks/>
     <div className='relative z-0'>
        <Contact/>
        <StarsCanvas/>
     </div>
   </div>
   </BrowserRouter>
  );
}

export default App;
